"use client"

// ============================================
// UPLOADS SECTION COMPONENT
// ============================================
import { FaFileUpload, FaFileAlt, FaEye, FaFileDownload } from "react-icons/fa"

const UploadsSection = ({
  selectedUser,
  mtcFiles,
  statementFiles,
  uploadProgress,
  handleFileUpload,
  handleDownload,
}) => {
  const renderUploadBlock = (title, description, fileType, files, inputId) => (
    <div className="upload-section">
      <div className="upload-header">
        <FaFileUpload className="upload-icon" />
        <div>
          <h3>{title}</h3>
          <p>{description}</p>
        </div>
      </div>

      <div className="upload-container">
        <input
          type="file"
          id={inputId}
          accept=".pdf,.jpg,.jpeg,.png"
          onChange={(e) => handleFileUpload(e, fileType)}
          className="file-input"
        />
        <label htmlFor={inputId} className="upload-button">
          <FaFileUpload /> Select File
        </label>

        {uploadProgress[fileType] !== null && uploadProgress[fileType] !== undefined && (
          <div className="progress-container">
            <div className="progress-bar" style={{ width: `${uploadProgress[fileType]}%` }} />
            <span className="progress-text">{uploadProgress[fileType]}%</span>
          </div>
        )}
      </div>

      <div className="files-list">
        <h4>
          <FaFileAlt /> Uploaded Files ({files.length})
        </h4>
        {files.length > 0 ? (
          <ul>
            {files.map((file, index) => (
              <li key={index} className="file-item">
                <FaFileAlt className="file-icon" />
                <span className="file-name" title={file.name}>
                  {file.name}
                </span>
                <div className="file-actions">
                  <button
                    onClick={() => window.open(file.url, "_blank")}
                    className="action-btn view-btn"
                    title="View File"
                  >
                    <FaEye />
                  </button>
                  <button
                    onClick={() => handleDownload(file.url, file.name)}
                    className="action-btn download-btn"
                    title="Download File"
                  >
                    <FaFileDownload />
                  </button>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p className="no-files">No files uploaded yet</p>
        )}
      </div>
    </div>
  )

  return (
    <div className="uploads-tab">
      <div className="section-header">
        <FaFileUpload className="section-icon" />
        <h2>Upload Files for {selectedUser.username || selectedUser.email}</h2>
      </div>
      <div className="upload-sections">
        {renderUploadBlock(
          "Material Test Certificate (MTC)",
          "Upload MTC files for this user. These will be available to all users.",
          "mtc",
          mtcFiles,
          "mtc-upload",
        )}
        {renderUploadBlock(
          "User Statements",
          "Upload statement files specific to this user.",
          "statement",
          statementFiles,
          "statement-upload",
        )}
      </div>
    </div>
  )
}

export default UploadsSection
